import { utcToZonedTime } from 'date-fns-tz';
import { AddressDetails, Country } from './types';

const COUNTRY_DEFAULT_TIMEZONE: Record<Country, string | undefined> = {
  AR: 'America/Argentina/Buenos_Aires',
  CL: 'America/Santiago',
  MX: 'America/Mexico_City',
  PE: 'America/Lima',
  UY: 'America/Montevideo',
  CO: 'America/Bogota',
  BR: 'America/Sao_Paulo',
  ES: 'Europe/Madrid',
  PY: 'America/Asuncion',
  XX: undefined,
};

export function getEstablishmentTimezone({
  addressDetails,
  countryCode,
}: {
  addressDetails?: AddressDetails;
  countryCode?: Country;
}): string | undefined {
  return (
    addressDetails?.timezone || (countryCode ? COUNTRY_DEFAULT_TIMEZONE[countryCode] : undefined)
  );
}

export function getDateReferenceForTimezone(timezone: string): Date {
  return utcToZonedTime(new Date(), timezone);
}

export function getEstablishmentDateReference(establishment: {
  addressDetails?: AddressDetails;
  countryCode?: Country;
}): Date {
  const timezone = getEstablishmentTimezone(establishment);

  return timezone ? getDateReferenceForTimezone(timezone) : new Date();
}
